import globals from '../../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const listarFilialSeller = async (pagina, idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/listar-filial-seller/${idEmpresa}/${pagina}/10`, 'GET')
}

export const listarFilialSellerComFiltro = async (idEmpresa, filtro, pagina) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/listar-filial-seller/${idEmpresa}/${filtro}/${pagina}/10`, 'GET')
}

export const detalheFilialSeller = async (idFilial) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/detalhes-filial-seller/${idFilial}`, 'GET')
}

export const cadastrarFilialSeller = async (data, idEmpresaSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/cadastrar-filial-seller/${idEmpresaSeller}`, 'POST', data)
}

export const editarFilialSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/atualizar-filial-seller`, 'PUT', data)
}

export const inativarFilialSeller = async (idFilial) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/inativar-filial-seller/${idFilial}`, 'PUT')
}

export const ativarFilialSeller = async (idFilial) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}FilialSeller/ativar-filial-seller/${idFilial}`, 'PUT')
}


export const gerarExelFilial = async (idEmpresa) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}FilialSeller/gerar-exel-filial/${idEmpresa}`, 'GET')
}

export const teste = async (idEmpresa) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}FilialSeller/teste/${idEmpresa}`, 'GET')
}